import { configureStore } from "@reduxjs/toolkit";
import locationsReducer from "../features/locationsSlice";
import BusinessReducer from "../features/businessSlice";
import DeliveryPartnerReducer from "../features/deliveryPartnerSlice";
import BankInformationReducer from "../features/bankInformationSlice";
import ParentAccountsReducer from "../features/parentAccountsSlice";
import DepositoryAssignmentsReducer from "../features/depositoryAssignmentsSlice";
import RefundAnalysisReducer from "../features/refundAnalysisSlice";
import { useDispatch } from "react-redux";

export const store = configureStore({
  reducer: {
    locations: locationsReducer,
    businessUnits: BusinessReducer,
    bankInformation: BankInformationReducer,
    parentAccounts: ParentAccountsReducer,
    depositoryAssignments: DepositoryAssignmentsReducer,
    fcrBusinessUnits: DeliveryPartnerReducer,
    deliveryPartners: DeliveryPartnerReducer,
    message: DeliveryPartnerReducer,
    refundAnalysisInformation: RefundAnalysisReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({}),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
